import { useContext } from "react";
import { AuthContext } from "./AuthContext";
import { AuthContextValue } from "./types";

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error(
      "useAuth must be called inside an AuthProvider. " +
        "Make sure AuthProvider wraps your component tree."
    );
  }

  return context;
}
